/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locationupdated1Inputs */

const en_locationupdated1 = /** @type {(inputs: Locationupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location updated`)
};

const de_locationupdated1 = /** @type {(inputs: Locationupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort aktualisiert`)
};

/**
* | output |
* | --- |
* | "Location updated" |
*
* @param {Locationupdated1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const locationupdated1 = /** @type {((inputs?: Locationupdated1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locationupdated1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_locationupdated1(inputs)
	return de_locationupdated1(inputs)
});
export { locationupdated1 as "locationUpdated" }